// import { Message } from 'element-ui'
import store from '@ps/store'
import gameIframe from '@ps/bridge/iframe/iframe'
import { scripts } from '@ps/bridge/qc/scripts'
import { nodeTypes } from '@ps/bridge/qc/scripts/editor'
import * as editorScript from '@ps/bridge/qc/scripts/editor'
import { executeAction, getAddNodeAction } from '@ps/workbench/undo-redo'
import {
  CarouselType,
  TriggerManual,
} from '@ps/views/workbench/right-pane/carousel/config'
import {
  carouselStyleDefaultConfig,
  switchArrayToObject,
} from '@ps/bridge/qc/scripts/carousel'
import { poolAction } from '@ps/bridge/resource/pool/index'
import nodePool from '@ps/bridge/qc/node-pool'
import {
  getCarouselNodeInScene,
  isCarouselPiteGroupNode,
  isCarouselResourceGroupNode,
} from '@ps/bridge/qc/base'
// import assets from '@ps/bridge/qc/assets'
import {
  setNodePosition,
  refreshTagMap,
  transNumToRealSize,
} from '@ps/bridge/qc/node/carousel'
import { updateAnotherResolutionLayout } from '@ps/store/workbench/common/layout'
import { drawRect } from '@ps/workbench/undo-redo/module/erase'

export default {
  async addCarousel({ state, dispatch }) {
    const gameOb = state.data.gameOb
    const targetSceneNode = store.state.workspace.sceneManager.currentSceneNode
    const carouselNode = gameOb.add.node(targetSceneNode)
    carouselNode.name = 'Carousel Component'
    carouselNode.width = gameIframe.UIRoot.width
    carouselNode.height = gameIframe.UIRoot.height
    // 添加默认轮播组
    // 挂载脚本与绑定节点
    carouselNode.addScript(scripts.carousel.name)
    const editorData = editorScript.getScript(carouselNode)
    editorData.$data.nodeType = nodeTypes.carousel
    editorData.$data.createFromPSScripts = [scripts.carousel.name]
    // 轮播组件默认设置为CarouselType.NormalCarousel
    await dispatch('setCarouselByPlayStyle', {
      playStyle: CarouselType.NormalCarousel,
      carouselNode,
    })
    // 添加默认轮播组
    await dispatch('addCarouselGroup', {
      carouselNode,
    })
    executeAction({
      action: getAddNodeAction({
        newValue: {
          node: carouselNode,
          parent: targetSceneNode,
          index: targetSceneNode.getChildIndex(carouselNode),
        },
        oldValue: {
          node: carouselNode,
          activeUuid: state.activeNode ? state.activeNode.uuid : '',
        },
      }),
    })
  },
  async addCarouselGroup({ state, dispatch }, { carouselNode }) {
    const gameOb = state.data.gameOb
    const anotherResolution =
      store.state.workspace.game.device.anotherResolution
    // 轮播组件
    const carouselComponent = carouselNode.getScript(scripts.carousel.name)
    // 创建组节点
    const carouselGroupNode = gameOb.add.node(carouselNode)
    carouselGroupNode.name = 'Carousel Group'
    const _defaultGroupSize = {
      width: 750,
      height: 750,
    }
    // 设置默认组宽高
    await store.dispatch('workspace/game/setStyle', {
      nodes: [
        {
          uuid: carouselGroupNode.uuid,
          width: _defaultGroupSize.width,
          height: _defaultGroupSize.height,
          x: carouselGroupNode.x,
          y: carouselGroupNode.y,
        },
      ],
      preNodes: [],
      record: false,
    })
    const groupEditorData = editorScript.getScript(carouselGroupNode)
    groupEditorData.$data.nodeType = nodeTypes.carouselGroup

    const imageAssetPath = 'resource/game/texture/'

    const defaultResource = {
      name: 'carousel-image.png',
      path: `${imageAssetPath}carousel-image.png`,
      paths: [`${imageAssetPath}carousel-image.png`],
      type: 'image',
    }

    const defaultPrev = {
      name: 'carousel-arrow-left.png',
      path: `${imageAssetPath}carousel-arrow-left.png`,
      paths: [`${imageAssetPath}carousel-arrow-left.png`],
      type: 'image',
    }

    const defaultNext = {
      name: 'carousel-arrow-right.png',
      path: `${imageAssetPath}carousel-arrow-right.png`,
      paths: [`${imageAssetPath}carousel-arrow-right.png`],
      type: 'image',
    }
    // 创建轮播组资源组节点
    const carouseRes = gameOb.add.node(carouselGroupNode)
    const resEditorData = editorScript.getScript(carouseRes)
    resEditorData.$data.nodeType = nodeTypes.carouselRes
    carouseRes.name = 'carousel-res'
    carouseRes.visible = false
    // 创建轮播组坑位组节点
    const piteSite = gameOb.add.node(carouselGroupNode)
    piteSite.name = 'carousel-pitSite'
    await store.dispatch('workspace/game/setStyle', {
      nodes: [
        {
          uuid: piteSite.uuid,
          width: 100,
          height: 100,
          x: piteSite.x,
          y: piteSite.y,
        },
      ],
      preNodes: [],
      record: false,
    })
    const piteEditorData = editorScript.getScript(piteSite)
    piteEditorData.$data.nodeType = nodeTypes.carouselPite
    // 添加默认资源
    const resource = await poolAction.add(defaultResource, carouseRes)
    resource.name = 'default_image'
    resource.uniqueName = resource.uuid
    const items = [resource.uuid]
    // 创建控制节点，添加图片资源
    const prevNode = await poolAction.add(defaultPrev, carouselGroupNode)
    prevNode.name = 'Carousel prev'
    const widthGap = (gameIframe.UIRoot.width - 750) / 2
    setNodePosition(prevNode, widthGap + 50, null)
    await store.dispatch('workspace/game/setStyle', {
      nodes: [
        {
          uuid: prevNode.uuid,
          width: 100,
          height: 100,
          x: prevNode.x,
          y: prevNode.y,
        },
      ],
      preNodes: [],
      record: false,
    })
    // 更新另外一个分辨率的 layout 信息
    setTimeout(() => {
      updateAnotherResolutionLayout({
        node: prevNode,
        anotherResolution,
        localPos: {
          x: prevNode.x,
          y: prevNode.y,
        },
      })
    }, 0)
    const nextNode = await poolAction.add(defaultNext, carouselGroupNode)
    nextNode.name = 'Carousel next'
    setNodePosition(nextNode, gameIframe.UIRoot.width - (widthGap + 50), null)
    await store.dispatch('workspace/game/setStyle', {
      nodes: [
        {
          uuid: nextNode.uuid,
          width: 100,
          height: 100,
          x: nextNode.x,
          y: nextNode.y,
        },
      ],
      preNodes: [],
      record: false,
    })
    // 更新另外一个分辨率的 layout 信息
    setTimeout(() => {
      updateAnotherResolutionLayout({
        node: nextNode,
        anotherResolution,
        localPos: {
          x: nextNode.x,
          y: nextNode.y,
        },
      })
    }, 0)
    // 创建坑位shadow节点
    const carouseShadowNode = gameOb.add.node(carouselGroupNode)
    carouseShadowNode.name = 'carousel-shadow'
    const shadowEditorData = editorScript.getScript(carouseShadowNode)
    shadowEditorData.$data.nodeType = nodeTypes.carouselShadow
    carouseShadowNode.visible = false
    gameOb.add.image(carouseShadowNode)
    const groupData = {
      carouselId: carouselGroupNode.uuid,
      items,
      prev: prevNode.uuid,
      next: nextNode.uuid,
      piteSite: piteSite.uuid,
      resource: carouseRes.uuid,
      shadow: carouseShadowNode.uuid,
      displayWidth:
        carouselStyleDefaultConfig[carouselComponent.playStyle].displayWidth,
      displayHeight:
        carouselStyleDefaultConfig[carouselComponent.playStyle].displayHeight,
      displaySpace:
        carouselStyleDefaultConfig[carouselComponent.playStyle].displaySpace,
      enable: true,
    }
    // 组装轮播组数据
    let carouselGroups = Object.values(carouselComponent.carouselGroups)
    if (carouselGroups.length > 0) {
      carouselGroups.push(groupData)
    } else {
      carouselGroups = [groupData]
    }
    carouselComponent.carouselGroups = switchArrayToObject(carouselGroups)
    await dispatch('updateCarouselGroup', {
      carouselNode,
    })
  },
  updateArrowVisibleByType({ state, dispatch }, config) {
    const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
    const carouselNode =
      config && config.carouselNode
        ? config.carouselNode
        : getCarouselNodeInScene(currentSceneNode)
    if (!carouselNode) return
    const carouselComponent = carouselNode.getScript(scripts.carousel.name)
    const carouselGroups = [...Object.values(carouselComponent.carouselGroups)]
    const setArrowVisibleByType = (group) => {
      let visible = false
      const preNode = nodePool.find(group.prev)
      const nextNode = nodePool.find(group.next)
      if (carouselComponent.triggerManual.includes(TriggerManual.click)) {
        visible = true
      } else {
        visible = false
      }
      preNode.visible = visible
      nextNode.visible = visible
    }
    carouselGroups.forEach((group, index) => {
      setArrowVisibleByType(group)
    })
  },
  // 刷新轮播组件（包含节点信息）
  async updateCarouselGroup({ state, dispatch }, config) {
    const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
    const carouselNode =
      config && config.carouselNode
        ? config.carouselNode
        : getCarouselNodeInScene(currentSceneNode)
    if (!carouselNode) return
    const carouselComponent = carouselNode.getScript(scripts.carousel.name)
    const carouselGroupsData = [
      ...Object.values(carouselComponent.carouselGroups),
    ]
    const carouselGroups = []
    const carouselChildUuids = carouselNode.children.map((item) => item.uuid)
    carouselChildUuids.forEach((uuid, index) => {
      const targetData = carouselGroupsData.find(
        (item) => item.carouselId === uuid,
      )
      let group = targetData || {}
      if (!targetData) {
        group = {
          ...group,
          ...{
            displayWidth:
              carouselStyleDefaultConfig[carouselComponent.playStyle]
                .displayWidth,
            displayHeight:
              carouselStyleDefaultConfig[carouselComponent.playStyle]
                .displayHeight,
            displaySpace:
              carouselStyleDefaultConfig[carouselComponent.playStyle]
                .displaySpace,
            enable: true,
          },
        }
      }
      // 更新轮播组节点uuid数据，保证结构一致
      if (!carouselChildUuids.includes(group.carouselId)) {
        group.carouselId = carouselNode.children[index].uuid
      }
      const groupChildUuids = carouselNode.children[index].children.map(
        (item) => item.uuid,
      )
      if (!groupChildUuids.includes(group.piteSite)) {
        group.piteSite = carouselNode.children[index].children.find((node) =>
          isCarouselPiteGroupNode(node),
        ).uuid
      }
      if (!groupChildUuids.includes(group.resource)) {
        group.resource = carouselNode.children[index].children.find((node) =>
          isCarouselResourceGroupNode(node),
        ).uuid
      }
      if (!groupChildUuids.includes(group.shadow)) {
        group.shadow = carouselNode.children[index].children.find(
          (node) => node.name.indexOf('carousel-shadow') > -1,
        ).uuid
      }
      if (!groupChildUuids.includes(group.prev)) {
        group.prev = carouselNode.children[index].children.find(
          (node) => node.name.indexOf('Carousel prev') > -1,
        ).uuid
      }
      if (!groupChildUuids.includes(group.next)) {
        group.next = carouselNode.children[index].children.find(
          (node) => node.name.indexOf('Carousel next') > -1,
        ).uuid
      }
      // 根据资源组节点获取全部资源，检查资源标签一致性
      const node = nodePool.find(group.resource)
      node.children.forEach((item) => {
        if (item.uniqueName !== item.uuid) {
          refreshTagMap({
            oldUuid: item.uniqueName,
            newUuid: item.uuid,
            carouselNode,
          })
          item.uniqueName = item.uuid
        }
      })
      group.items = node.children.map((item) => item.uuid).reverse()
      if (config && config.refreshGroupSize) {
        group.displayWidth =
          carouselStyleDefaultConfig[carouselComponent.playStyle].displayWidth
        group.displayHeight =
          carouselStyleDefaultConfig[carouselComponent.playStyle].displayHeight
        group.displaySpace =
          carouselStyleDefaultConfig[carouselComponent.playStyle].displaySpace
      }
      // 根据坑位尺寸重置shadow图片节点尺寸
      const shadowImage = nodePool.find(group.shadow).children[0]
      store.dispatch('workspace/game/setStyle', {
        nodes: [
          {
            uuid: shadowImage.uuid,
            x: 0,
            y: 0,
            width: transNumToRealSize(
              group.displayWidth,
              group.piteSite,
              'displayWidth',
            ),
            height: transNumToRealSize(
              group.displayHeight,
              group.piteSite,
              'displayHeight',
            ),
          },
        ],
        preNodes: [],
        record: false,
      })
      drawRect(shadowImage, { color: '#f3ad0280' })
      carouselGroups.push(group)
    })
    carouselComponent.carouselGroups = switchArrayToObject(carouselGroups)
    await dispatch('resetCarousel', {
      carouselNode,
    })
  },
  setCarouselGroup(
    { state, dispatch },
    { prop, value, carouselNode, carouselGroup },
  ) {
    const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
    const currentCarouselNode =
      carouselNode || getCarouselNodeInScene(currentSceneNode)
    const carouselComponent = currentCarouselNode.getScript(
      scripts.carousel.name,
    )
    const carouselGroups = [...Object.values(carouselComponent.carouselGroups)]
    const currentCarouselGroup = carouselGroups.find(
      (item) => item.carouselId === carouselGroup.carouselId,
    )
    currentCarouselGroup[prop] = value
    carouselComponent.carouselGroups = switchArrayToObject(carouselGroups)
    dispatch('updateCarouselGroup', {
      carouselNode,
    })
  },
  // 刷新轮播组件
  resetCarousel({ state, dispatch }, config) {
    const currentSceneNode = store.state.workspace.sceneManager.currentSceneNode
    const carouselNode =
      config && config.carouselNode
        ? config.carouselNode
        : getCarouselNodeInScene(currentSceneNode)
    if (carouselNode) {
      const carouselComponent = carouselNode.getScript(scripts.carousel.name)
      dispatch('updateArrowVisibleByType')
      carouselComponent.vpInitCarousel()
    }
  },
  updateCarousel(
    { state, dispatch },
    { setting, carouselNode, refresh = false },
  ) {
    const carouselComponent = carouselNode.getScript(scripts.carousel.name)
    for (const key in setting) {
      carouselComponent[key] = setting[key]
      if (key === 'triggerManual') {
        dispatch('updateArrowVisibleByType')
      }
    }
    if (refresh) {
      dispatch('updateCarouselGroup', {
        carouselNode,
      })
    }
  },
  setCarouselByPlayStyle({ state, dispatch }, { playStyle, carouselNode }) {
    const carouselComponent = carouselNode.getScript(scripts.carousel.name)
    // 轮播风格
    carouselComponent.playStyle = playStyle
    const {
      direction,
      playMode,
      triggerManual,
      stayTime,
      enableScaleMask,
      displayNum,
      animationDuration,
      enableComponent,
      carouselOpacity,
      carouselScale,
    } = carouselStyleDefaultConfig[playStyle]
    // 轮播方式
    carouselComponent.playMode = playMode
    // 轮播方向
    carouselComponent.direction = direction
    // 交互方式
    carouselComponent.triggerManual = triggerManual
    // 轮播间隔
    carouselComponent.stayTime = stayTime
    // 遮罩开关
    carouselComponent.enableScaleMask = enableScaleMask
    // 坑位数
    carouselComponent.displayNum = displayNum
    // 动画时长
    carouselComponent.animationDuration = animationDuration
    // 轮播组件开关
    carouselComponent.enableComponent = enableComponent
    // 轮播动画透明度范围
    carouselComponent.carouselOpacity = carouselOpacity
    // 轮播动画缩放范围
    carouselComponent.carouselScale = carouselScale
    dispatch('updateCarouselGroup', {
      carouselNode,
      refreshGroupSize: true,
    })
  },
}
